import { writeBatch } from 'firebase/firestore';
import { db } from './firebase.utils';
import { isStaged } from '../sales/sales.constants';
import { EBAY_LOTS_CATEGORY_ID, EBAY_SINGLES_CATEGORY_ID } from '../ebay/ebayListingText';
import { transactionDoc } from './transactionPaths';
import { mintEbaySkus } from './ebay';

/**
 * Moves staged rows to another platform. Listed sales stay put.
 * eBay and Whatnot rows gain a SKU when they do not already have one.
 */
export async function reassignStagedItems(uid, items, platform) {
  const staged = (items ?? []).filter((item) => item?.id && isStaged(item.status) && item.platform !== platform);
  if (!uid || !platform || staged.length === 0) return;

  const needsSku = platform === 'eBay' || platform === 'Whatnot';
  const missing = needsSku ? staged.filter((item) => !item.sku) : [];
  const source = platform === 'eBay' ? 'ebay' : 'whatnot';
  const skus = missing.length ? await mintEbaySkus(uid, missing.length, source) : [];
  const skuById = {};
  missing.forEach((item, index) => {
    skuById[item.id] = skus[index];
  });

  const batch = writeBatch(db);
  staged.forEach((item) => {
    const patch = { platform };
    if (skuById[item.id]) patch.sku = skuById[item.id];
    if (platform === 'eBay') {
      if (item.categoryId == null) {
        patch.categoryId = item.type === 'lot' ? EBAY_LOTS_CATEGORY_ID : EBAY_SINGLES_CATEGORY_ID;
      }
      if (item.conditionId == null) patch.conditionId = '2750';
      if (item.format == null) patch.format = 'FixedPrice';
      if (item.price == null) patch.price = '1';
    }
    batch.update(transactionDoc(uid, item.id), patch);
  });
  await batch.commit();
}
